import { render, staticRenderFns } from "./CoinBadge.vue?vue&type=template&id=6f1d3145&"
import script from "./CoinBadge.vue?vue&type=script&lang=js&"
export * from "./CoinBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports